import { render, staticRenderFns } from "./OnMaintenance.vue?vue&type=template&id=31c2ebb5&scoped=true"
import script from "./OnMaintenance.vue?vue&type=script&lang=js"
export * from "./OnMaintenance.vue?vue&type=script&lang=js"
import style0 from "./OnMaintenance.vue?vue&type=style&index=0&id=31c2ebb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2ebb5",
  null
  
)

export default component.exports